import { RendererContextType } from '../../../../contexts/RendererContext';
import { ProjectByIdQuery } from '../../../../types/graphqlTypes';
import { BoxVolume } from '../../../../potree/utils/Volume';
import { ensureClipMethodPropertyRegistered } from '@pointorama/potree-shared';
import { ensureFilterTogglePropertyRegistered } from '../../../../modules/Properties/integration/annotations/FilterToggleProperty';
import { SyncConfig } from './syncFromGraphQL';

type Project = ProjectByIdQuery['projectById'];
type Annotation = Project['state']['annotations'][number];

export function createSyncBoxesConfig({ viewer, annotations }: { viewer: NonNullable<RendererContextType['viewer']>; annotations: Annotation[] }): SyncConfig<Annotation, BoxVolume> {
  return {
    getSourceItems: () => annotations.filter((a) => a.type === 'BOX'),
    getSceneItems: () => viewer.scene.volumes.filter((v): v is BoxVolume => v instanceof BoxVolume && v.finished),
    getSourceIdentifier: (item) => item.identifier,
    getSceneIdentifier: (item) => item.identifier,
    // update() omitted — geometry updates are handled by reactive property subscriptions
    create: (source, existing) => {
      return new BoxVolume({
        identifier: source.identifier,
        clip: true,
        finished: true,
        selected: existing?.selected || false,
      });
    },
    addToScene: (item) => {
      // volumeScene sync is handled by viewer's volume_added listener
      viewer.scene.addVolume(item);
    },
    removeFromScene: (item) => {
      item.dispose();
      // volumeScene sync + gizmo target clearing handled by viewer/BoxPersonaTool listeners
      viewer.scene.removeVolume(item);
    },
    afterCreate: (item) => {
      ensureClipMethodPropertyRegistered(item.identifier);
      ensureFilterTogglePropertyRegistered(item.identifier);
      item.loadReactiveProperties();
    },
  };
}
